export { idlFactory } from './idlFactory';
export * from '../../../declarations/encrypted_notes_motoko/encrypted_notes_motoko.did.js';
export const ENCRYPTED_NOTES_CANISTER_ID = process.env.ENCRYPTED_NOTES_MOTOKO_CANISTER_ID;
